import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, withStateHandlers } from 'recompose';
import { addToFavPortfolio } from '../../actions';
import config from 'cfg';
import RCore from 'RCore';
// import { browserDownloadWidget2image } from '../../../../../widgets/actions/widgets';

import { browserHistory } from 'react-router';
import IconDownload from 'material-ui/svg-icons/file/file-download';
import IconOpenInNew from 'material-ui/svg-icons/action/open-in-new';

import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconCampaigns from 'material-ui/svg-icons/places/all-inclusive';
import CircularProgress from 'material-ui/CircularProgress';
import IconStyle from 'material-ui/svg-icons/image/style';
// import IconAddToFav from 'material-ui/svg-icons/action/favorite';
import IconNext from 'material-ui/svg-icons/navigation/chevron-right';
import { IconButton, IconMenu, MenuItem, FlatButton } from 'material-ui';
import { browserDownloadWidget2image, browserDownloadWidget2video } from 'widgets/actions/widgets';

const mapStateToProps = ({ user, editor }) => {
    const { widget } = editor;
    var widgetUrl =
        widget &&
        config.WDPLinkr.widget.sm(user.client, user.username, 'default', widget.id, {
            ...RCore.prepareWidgetPropsObj(editor.widgetProps),
            __mode: 'strict',
        });
    if (widget && widget.spec.video) {
        widgetUrl =
            widget &&
            config.WDPLinkr.widget.animated(user.client, user.username, 'default', widget.id, {
                ...RCore.prepareWidgetPropsObj(editor.widgetProps),
                js: true,
            });
    }

    return {
        user,
        widget,
        widgetUrl,
        ...editor,
    };
};

const mapDispatchToProps = { addToFavPortfolio };

const MoreMenu = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    withStateHandlers(
        () => ({
            downloading: false,
        }),
        {
            onStartDownload: () => () => ({
                downloading: true,
            }),
            onEndDownload: () => () => ({
                downloading: false,
            }),
        },
    ),
    lifecycle({
        componentWillReceiveProps() {},
        componentDidMount() {},
    }),
)(({ widget, user, widgetProps, widgetUrl, downloading, onStartDownload, onEndDownload }) => (
    <IconMenu
        key="cmpa"
        iconButtonElement={
            <IconButton>
                <MoreVertIcon />
            </IconButton>
        }
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
        {/* <MenuItem disabled leftIcon={<IconLink />} primaryText="Get Links" /> */}
        <MenuItem
            leftIcon={downloading ? <CircularProgress /> : <IconDownload />}
            primaryText="Download"
            onTouchTap={() => {
                onStartDownload();
                browserDownloadWidget2image(widget, widgetUrl).then(onEndDownload);
            }}
        />

        <MenuItem
            leftIcon={<IconStyle />}
            primaryText="Edit widget theme"
            onTouchTap={() =>
                browserHistory.push({
                    pathname: `/sm/templates/edit`,
                    query: {
                        tid: widgetProps.template,
                        wid: widget.id,
                        variation: widgetProps.variation,
                    },
                })
            }
        />
        <MenuItem
            leftIcon={<IconOpenInNew />}
            primaryText="Open in new window"
            onTouchTap={() => {
                let url;

                if (widget.spec.video) {
                    url = config.WDPLinkr.widget.animated(user.client, user.username, 'default', widget.id, {
                        ...RCore.prepareWidgetPropsObj(widgetProps),
                    });
                } else {
                    url = config.WDPLinkr.widget.sm(user.client, user.username, 'default', widget.id, {
                        ...RCore.prepareWidgetPropsObj(widgetProps),
                    });
                }

                window.open(url, '_blank');
            }}
        />
    </IconMenu>
));

function Controls({
    user,
    widget,
    widgetId,
    widgetProps,
    widgetUrl,

    downloading,
    onStartDownload,
    onEndDownload,
    style,
    mainAction,
}) {
    return (
        <div style={{ display: 'flex', alignItems: 'center', ...style }}>
            <IconButton
                key="Download"
                tooltip="Download"
                onClick={() => {
                    onStartDownload();
                    if (widget.spec.video) {
                        browserDownloadWidget2video(widget, widgetUrl).then(onEndDownload);
                    } else {
                        // js: true,
                        browserDownloadWidget2image(widget, widgetUrl).then(onEndDownload);
                    }
                }}
            >
                {downloading ? <CircularProgress size={24} /> : <IconDownload />}
            </IconButton>
            <IconButton href={widgetUrl} target="_blank" key="onw">
                <IconOpenInNew />
            </IconButton>
            {widget &&
                !widget.spec.video && (
                    <FlatButton
                        label="Post to campaign"
                        onClick={() => {
                            const schedulePost = JSON.stringify({
                                widgetId,
                                widgetProps,
                            });
                            localStorage.setItem('schedule_post', schedulePost);
                            window.location.href = '/v2/calendar?calendarView=month';
                        }}
                    />
                )}
            <MoreMenu />
            <div style={{ flexGrow: 1 }} />
            {mainAction}
        </div>
    );
}

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    withStateHandlers(
        () => ({
            downloading: false,
        }),
        {
            onStartDownload: () => () => ({
                downloading: true,
            }),
            onEndDownload: () => () => ({
                downloading: false,
            }),
        },
    ),
    lifecycle({
        componentWillReceiveProps() {},
        componentDidMount() {},
    }),
)(Controls);



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/components/controls/Controls.js
 **/